/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ファイル情報
 */
export interface FileInfo { 
    /**
     * ファイル名
     */
    fileName?: string;
    /**
     * ファイルサイズ
     */
    fileSize?: number;
    /**
     * 最終更新日付：日付(yyyyMMddHHmmss)
     */
    lastUpdateDate?: string;
}

